(function () {
    'use strict';

    angular.module("imApp").factory("p2TerminalsService", ['$ihttp', function ($ihttp) {
        let service = {
            listTerminals: function (parms) {
                return $ihttp.post({
                    method: 341,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
